import React from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { useImageGeneration } from '.';

export default function PromptTextarea() {
  const { prompt, setPrompt } = useImageGeneration();

  return (
    <div className='flex flex-col space-y-2 px-4'>
      <Label
        htmlFor='prompt'
        className='text-base font-semibold text-neutral-50 leading-tight'
      >
        Prompt
      </Label>

      <Textarea
        id='prompt'
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        placeholder='Describe your image. Get creative...'
        className='min-h-[76px] bg-neutral-800 border border-white/10 text-stone-50/90 text-sm placeholder:text-stone-50/90/40 focus:ring-2 focus:ring-fuchsia-600/50 focus:border-fuchsia-600 transition'
      />
    </div>
  );
}
